<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        props: {
            item: Object,
            type: String
        }
    }
</script>

<template>
    <a :href="item.detailUrl" :class="['image-link', type === 'simple' ? 'image-link--simple' : 'has-mask']">
        <div class="image-link-image-wrapper has-mask">
            <span class="image-link-tag" v-if="item.type && item.type.name && type !== 'simple'">{{ item.type.name }}</span>
            <template v-if="item.image && item.image.length">
                <source-set :imageSets="item.image"  image-class="image-link-image" />
            </template>
            <picture class="image-link-image image-link-image--fallback" v-else>
                <img src="/svg/one-planet.svg" alt="One Planet" loading="lazy" :width="type === 'simple' ? 509 : 455" :height="type === 'simple' ? 243 : 217">
            </picture>
        </div>
        <div class="image-link-content">
            <time :datetime="item.date" class="is-size-6 has-text-weight-medium" v-if="item.date">{{ toDateStr(item.date) }}</time>
            <span class="image-link-tag has-border mb-1" v-if="item.age && item.age.name && type !== 'simple'">{{ item.age.name }}</span>
            <h3 class="title is-4 image-link-title" v-if="item.title">
                <span>{{ item.title }}</span>
                <span class="image-link-icon" v-if="type !== 'simple'"><img src="/svg/arrow-right.svg" alt="arrow right" width="18" height="12" loading="lazy"></span>
            </h3>
            <span class="image-link-tag has-background-warning" v-if="item.subject && item.subject.name && type !== 'simple'">{{ item.subject.name }}</span>
        </div>
    </a>
</template>
